<template>
    <div class="message-centre-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Users</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <users-table/>
        </div>
    </div>
</template>

<script>
    import UsersTable from "@/components/main/data-tables/UsersTable";

    export default {
        components: {
            UsersTable
        }
    }
</script>

<style scoped>

</style>
